import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { DecisionTypeDto } from '@shared/interfaces/dtos/decision-types';

@Injectable({
  providedIn: 'root',
})
export class DecisionTypesService extends BaseHttpService {
  protected endPoint: string = 'Global/TypesDecisions';

  public fetchDecisionTypes(): Observable<DecisionTypeDto[]> {
    return this.http.get<DecisionTypeDto[]>(this.buildURL());
  }
}
